var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector45(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 402,
    viewBox: "0 0 250 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.362 400.535C223.509 374.004 219.757 368.457 205.248 342.759C201.693 336.464 196.392 324.448 191.76 309.874C190.372 305.512 189.16 301.209 188.089 296.984C180.459 266.753 183.274 234.464 190.368 203.175C208.471 123.34 174.867 44.3496 111.607 13.8966C48.2383 -16.6063 -30.2789 8.19133 -73.8092 57.8592C-79.4728 64.322 -104.76 95.0186 -112.923 131.417C-138.729 246.336 -32.5634 308.433 133.906 367.407C137.145 368.552 152.654 373.358 155.957 374.291L248.372 400.548L248.362 400.535Z",
    stroke: "#E1E3E9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector45);
export default __webpack_public_path__ + "static/media/vector4-5.2a3852d80ad17c07ef175584c272c549.svg";
export { ForwardRef as ReactComponent };